var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenshotEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 634133"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "monitor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.044 25.9141H70.8979C81.4253 25.9141 84.0571 28.5459 84.0571 39.0438V57.7625C84.0571 68.2899 81.4253 70.8922 70.9274 70.8922H38.044C27.5461 70.9218 24.9143 68.2899 24.9143 57.7921V39.0438C24.9143 28.5459 27.5461 25.9141 38.044 25.9141Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "document-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M64.109 37.6688V47.6931C64.109 50.7003 62.6053 52.7052 59.0969 52.7052H51.0775C47.569 52.7052 46.0654 50.7003 46.0654 47.6931V37.6688C46.0654 34.6616 47.569 32.6567 51.0775 32.6567H59.0969C62.6053 32.6567 64.109 34.6616 64.109 37.6688Z",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M51.0775 37.6687H55.0872",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M51.4785 42.6809H58.6959",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M51.0775 47.6931H59.0969",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M54.4857 70.9221V85.0573",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M24.9143 58.4431H84.0571",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M41.1786 85.0574H67.7929",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 634151"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 197",
    cx: 80.7143,
    cy: 31.3143,
    r: 9.53571,
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M85.2595 34.2337C84.9851 33.9616 84.6336 33.7807 84.2527 33.7158C83.8718 33.6508 83.4802 33.7049 83.1312 33.8707L81.6852 32.4309L83.7196 30.4028C83.8374 30.2849 83.9037 30.1251 83.9037 29.9584C83.9037 29.7917 83.8374 29.6318 83.7196 29.5139C83.6017 29.3961 83.4418 29.3298 83.2751 29.3298C83.1084 29.3298 82.9486 29.3961 82.8307 29.5139L80.8026 31.5483L78.7744 29.5139C78.6565 29.3961 78.4967 29.3298 78.33 29.3298C78.1633 29.3298 78.0034 29.3961 77.8855 29.5139C77.7677 29.6318 77.7014 29.7917 77.7014 29.9584C77.7014 30.1251 77.7677 30.2849 77.8855 30.4028L79.9199 32.4309L78.4739 33.8769C78.1241 33.7174 77.7345 33.6661 77.3552 33.7297C76.9759 33.7932 76.6244 33.9688 76.3457 34.2337C76.1611 34.4057 76.0132 34.613 75.9105 34.8433C75.8079 35.0737 75.7527 35.3224 75.7482 35.5745C75.7438 35.8266 75.7902 36.0771 75.8846 36.3109C75.9791 36.5448 76.1197 36.7572 76.298 36.9355C76.4763 37.1138 76.6887 37.2544 76.9226 37.3489C77.1564 37.4433 77.4068 37.4897 77.659 37.4852C77.9111 37.4808 78.1598 37.4256 78.3902 37.323C78.6205 37.2203 78.8278 37.0723 78.9998 36.8878C79.352 36.536 79.5502 36.0587 79.5506 35.5608C79.549 35.281 79.4848 35.0051 79.3628 34.7533L80.8026 33.3136L82.2423 34.7533C82.1203 35.0051 82.0561 35.281 82.0545 35.5608C82.0542 35.8697 82.1302 36.174 82.2756 36.4465C82.4211 36.7191 82.6315 36.9516 82.8883 37.1233C83.1451 37.2951 83.4403 37.4009 83.7477 37.4312C84.0552 37.4616 84.3654 37.4157 84.6508 37.2975C84.9363 37.1793 85.1881 36.9925 85.3841 36.7537C85.5801 36.5149 85.7141 36.2314 85.7743 35.9283C85.8345 35.6253 85.819 35.3121 85.7292 35.0165C85.6394 34.7209 85.478 34.4521 85.2595 34.2337ZM78.1171 36.0052C78.059 36.0639 77.9897 36.1105 77.9134 36.1422C77.8372 36.174 77.7553 36.1904 77.6727 36.1904C77.5901 36.1904 77.5083 36.174 77.432 36.1422C77.3557 36.1105 77.2865 36.0639 77.2283 36.0052C77.1412 35.9175 77.0821 35.8059 77.0584 35.6846C77.0347 35.5634 77.0473 35.4378 77.0949 35.3237C77.1424 35.2096 77.2226 35.1121 77.3255 35.0436C77.4283 34.975 77.5491 34.9384 77.6727 34.9384C77.7963 34.9384 77.9171 34.975 78.0199 35.0436C78.1228 35.1121 78.203 35.2096 78.2505 35.3237C78.2981 35.4378 78.3108 35.5634 78.287 35.6846C78.2633 35.8059 78.2042 35.9175 78.1171 36.0052ZM84.3768 36.0052C84.3186 36.0639 84.2494 36.1105 84.1731 36.1422C84.0969 36.174 84.015 36.1904 83.9324 36.1904C83.8498 36.1904 83.7679 36.174 83.6917 36.1422C83.6154 36.1105 83.5462 36.0639 83.488 36.0052C83.4293 35.947 83.3827 35.8778 83.3509 35.8015C83.3192 35.7252 83.3028 35.6434 83.3028 35.5608C83.3028 35.4782 83.3192 35.3963 83.3509 35.3201C83.3827 35.2438 83.4293 35.1745 83.488 35.1164C83.5462 35.0577 83.6154 35.0111 83.6917 34.9793C83.7679 34.9476 83.8498 34.9312 83.9324 34.9312C84.015 34.9312 84.0969 34.9476 84.1731 34.9793C84.2494 35.0111 84.3186 35.0577 84.3768 35.1164C84.4355 35.1745 84.4821 35.2438 84.5139 35.3201C84.5456 35.3963 84.562 35.4782 84.562 35.5608C84.562 35.6434 84.5456 35.7252 84.5139 35.8015C84.4821 35.8778 84.4355 35.947 84.3768 36.0052Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M86.4363 26.1714H75.1688C75.0028 26.1714 74.8436 26.2373 74.7262 26.3547C74.6088 26.4721 74.5429 26.6313 74.5429 26.7974V33.057C74.5429 33.2231 74.6088 33.3823 74.7262 33.4997C74.8436 33.6171 75.0028 33.683 75.1688 33.683C75.3348 33.683 75.4941 33.6171 75.6115 33.4997C75.7288 33.3823 75.7948 33.2231 75.7948 33.057V27.4233H85.8103V33.057C85.8103 33.2231 85.8763 33.3823 85.9936 33.4997C86.111 33.6171 86.2703 33.683 86.4363 33.683C86.6023 33.683 86.7615 33.6171 86.8789 33.4997C86.9963 33.3823 87.0622 33.2231 87.0622 33.057V26.7974C87.0622 26.6313 86.9963 26.4721 86.8789 26.3547C86.7615 26.2373 86.6023 26.1714 86.4363 26.1714Z",
    fill: "#EFEFEF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshotEmpty);
export default __webpack_public_path__ + "static/media/screenshotEmpty.7bebe53334493c5767138b9dc2351d51.svg";
export { ForwardRef as ReactComponent };